var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"table-label",attrs:{"small":"","label":"","dark":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }